export const TOP_BAR_ITEMS = {
  BACK: 'BACK',
  EPISODES: 'EPISODES',
};
